export enum BorrowStep {
    Collateral = "Collateral",
    Principal = "Amount",
    Duration = "Duration"
}
export const BORROW_STEPS = [BorrowStep.Collateral, BorrowStep.Principal];
